<template>
   <div class="content-features-section">
      <PageFrameContainer>
         <div class="content-features">
            <AnimatedCard :title="$t('pages.main.contentFeatures.video.title')" icon="main/content-features/content-video.svg" :desc="$t('pages.main.contentFeatures.video.desc')">
               {{$t('pages.main.contentFeatures.video.text')}}
            </AnimatedCard>
            <AnimatedCard :title="$t('pages.main.contentFeatures.pictures.title')" icon="main/content-features/content-pic.svg" :desc="$t('pages.main.contentFeatures.pictures.desc')">
               {{$t('pages.main.contentFeatures.pictures.text')}}
            </AnimatedCard>
            <AnimatedCard :title="$t('pages.main.contentFeatures.multiscreen.title')" icon="main/content-features/content-not-form.svg" :desc="$t('pages.main.contentFeatures.multiscreen.desc')">
               {{$t('pages.main.contentFeatures.multiscreen.text')}}
            </AnimatedCard>
            <AnimatedCard :title="$t('pages.main.contentFeatures.html.title')" icon="main/content-features/content-html.svg" :desc="$t('pages.main.contentFeatures.html.desc')">
               {{$t('pages.main.contentFeatures.html.text')}}
            </AnimatedCard>
            <AnimatedCard :title="$t('pages.main.contentFeatures.link.title')" icon="main/content-features/content-url.svg" :desc="$t('pages.main.contentFeatures.link.desc')" link="https://mcdist1.wixsite.com/wix-fullhd-project">
               {{$t('pages.main.contentFeatures.link.text')}}
            </AnimatedCard>
            <AnimatedCard :title="$t('pages.main.contentFeatures.slides.title')" icon="main/content-features/content-slide.svg"
                                          :desc="$t('pages.main.contentFeatures.slides.desc')" link="https://docs.google.com/presentation/d/e/2PACX-1vRtVHVf91hGOVCnW3sgYTHEHHqRhFrrqUpJzJSvLUwFHnmUf8LHr3g2Fl2RYI755wPAi4FuUdGLFD0B/pub?start=true&loop=true&delayms=3000">
               {{$t('pages.main.contentFeatures.slides.text')}}
            </AnimatedCard>
         </div>
      </PageFrameContainer>
   </div>
</template>

<script>
    import AnimatedCard from "../../../components/AnimatedCard";
    import PageFrameContainer from "../../../components/PageFrameContainer";

    export default {
        name: "ContentFeaturesSection",
        components: {PageFrameContainer, AnimatedCard}
    }
</script>

<style scoped lang="scss">
   @import "../../../theme/theme";

   .content-features-section {
      padding-top: 3em;
      padding-bottom: 3em;
   }

   .content-features {
      display: grid;
      grid-gap: 1.5em;
   }

   @media (max-width: 40em) {
      .content-features {
         grid-template-columns: 1fr;
      }
   }
   @media (min-width: 40em) and (max-width: 60em) {
      .content-features {
         grid-template-columns: 1fr 1fr;
      }
   }

   @media (min-width: 60em) {
      .content-features {
         grid-template-columns: 1fr 1fr 1fr;
      }
   }

</style>